import { LaunchedPageId, StatementOptions, VERB_ID } from '@/components/C1Opener/OpenerTypes';
import { sendMessageToContainer } from '@/components/C1Opener/SendMessageUtils';
import { MessagingChannel } from 'jschannel';

export async function sendLaunchedStatement(
    channel: MessagingChannel,
    contentId: string,
    pageId: LaunchedPageId,
    title: string,
    options?: StatementOptions
): Promise<unknown> {
    const verbId = options?.verbId ?? VERB_ID;
    return sendMessageToContainer(channel, 'newStatements', [
        {
            verb: {
                id: `${verbId}/launched`,
                display: {
                    und: 'launched'
                }
            },
            object: {
                id: `${contentId}/${pageId}`,
                title: title // Title to display on the IFrame
            }
        }
    ]);
}